import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { Button } from "react-bootstrap";
import ReactSelect from "../../UI/ReactSelectNotClear";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ReactSelectMulti from "../../UI/ReactMultiSelect";

export default function Filter(props) {
  const { onHide, show, filterInputsUpdate, filterInputs, setFilterInputs, appointmentSelect, devicePlaceId, deviceModelId, deviceTypeId } = props;
  const [chooseOption, setChooseOption] = useState([]);
  const [chooseModelOption, setChooseModelOption] = useState([]);
  const [chooseTypeOption, setChooseTypeOption] = useState([]);
  const [appointmentOption, setAppointmentOption] = useState(null);

  function handleChangePlace(value) {
    setChooseOption(value);
    filterInputsUpdate("devicePlaceId", value.value);

  }
  function handleChangeModel(value) {
    setChooseModelOption(value);
    filterInputsUpdate("deviceModelId", value.value);

  } function handleChangeType(value) {
    setChooseTypeOption(value);
    filterInputsUpdate("deviceTypeId", value.value);

  }
  function handleChangeAppointment(value) {
    setAppointmentOption(value);
    const mockArray = []
    if (value) {
      value.forEach(element => {
        mockArray.push(element.value)
      })
    }
    filterInputsUpdate("appointment", mockArray);
  }
  
  const [opens, setOpens] = React.useState(false);

  function handleCloses() {
    setOpens(false);
  }

  function handleOpens() {
    setOpens(true);
  }

  const [openStatus, setOpenStatus] = React.useState(false);

  function handleCloseStatus() {
    setOpenStatus(false);
  }

  function handleOpenStatus() {
    setOpenStatus(true);
  }

  const onResetFilter = () => {
    setFilterInputs({

      name: "",
    });
    setChooseOption(null)
    setChooseModelOption(null)
    setChooseTypeOption(null)
    setAppointmentOption(null);

    onHide(false)
  }
  return (
    <Modal
      size="lg"
      show={show}
      onHide={onHide}
      aria-labelledby="create"
      centered
      className="modal pr-0"
    >
      <Modal.Header closeButton>
        <Modal.Title id="create">Qurğuların filtri</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 pl-4 pr-4">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="name"
                  name="name"
                  label="Qurğu adı "
                  placeholder="Qurğu adı "
                  className="w-100"
                  value={filterInputs.name}
                  onChange={(e) =>
                    filterInputsUpdate("name", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={devicePlaceId}
                  handleChangeSingle={(value) => handleChangePlace(value)}
                  single={chooseOption}
                  label="Qurğu məkanı  seçin"
                  placeholder="Qurğu məkanı seçin"
                  inputId="devicePlaceId"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={deviceModelId}
                  handleChangeSingle={(value) => handleChangeModel(value)}
                  single={chooseModelOption}
                  label="Qurğu modeli  seçin"
                  placeholder="Qurğu modeli seçin"
                  inputId="deviceModelId"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelect
                  suggestions={deviceTypeId}
                  handleChangeSingle={(value) => handleChangeType(value)}
                  single={chooseTypeOption}
                  label="Qurğu tipi  seçin"
                  placeholder="Qurğu tipi seçin"
                  inputId="deviceTypeId"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <ReactSelectMulti
                  suggestions={appointmentSelect}
                  handleChangeSingle={(value) => handleChangeAppointment(value)}
                  single={appointmentOption}
                  label="Təyinat seçin"
                  placeholder="Təyinat seçin"
                  inputId="appointment"
                />
               
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <FormControl className="w-100">
                  <InputLabel htmlFor="role">İstiqamət </InputLabel>
                  <Select
                    open={opens}
                    onClose={handleCloses}
                    onOpen={handleOpens}
                    value={filterInputs.direction}
                    onChange={(e) =>
                      filterInputsUpdate("direction", e.target.value)
                    }
                    inputProps={{
                      name: "direction",
                      id: "direction",
                    }}
                  >

                    <MenuItem value="ENTRANCE">Giriş</MenuItem>
                    <MenuItem value="EXIT">Çıxış</MenuItem>
                    <MenuItem value="ENTRANCE_EXIT">Giriş/Çıxış</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <FormControl className="w-100">
                  <InputLabel htmlFor="role">Vəziyyət </InputLabel>
                  <Select
                    open={openStatus}
                    onClose={handleCloseStatus}
                    onOpen={handleOpenStatus}
                    value={filterInputs.status}
                    onChange={(e) =>
                      filterInputsUpdate("status", e.target.value)
                    }
                    inputProps={{
                      name: "status",
                      id: "status",
                    }}
                  >
                    <MenuItem value="ONLINE">Online</MenuItem>
                    <MenuItem value="OFFLINE">Ofline</MenuItem>

                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                <TextField
                  id="ipAddress"
                  name="ipAddress"
                  label="İp ünvanı  "
                  placeholder="İp ünvanı "
                  className="w-100"
                  value={filterInputs.ipAddress}
                  onChange={(e) =>
                    filterInputsUpdate("ipAddress", e.target.value)
                  }
                // onChange={(e) => filterInputsUpdate(e)}
                />
              </div>
            </div>

          </div>
          <div className="d-flex justify-content-end">  <Button
            variant="primary"
            onClick={() => {
              onResetFilter();
            }}
            className="mt-4"
          >
            Sıfırla
          </Button>
            <Button
              variant="success"
              onClick={() => {
                onHide(false);
              }}
              className="mt-4 ml-4"
            >
              Tamam
            </Button></div>

        </div>
      </Modal.Body>
    </Modal>
  );
}
